import { forwardRef, useState } from 'react';
import { Input, InputRef } from 'antd';
import { CancelIcon, SearchIcon } from 'shared/ui/Icons/Icons';
import { styled } from 'styled-components';

import { IHeaderSearchInputProps } from '../models/types';
import { HeaderSearchInputProvider } from '../providers';

import styles from './styles.module.scss';

const StyledInput = styled(Input)`
  align-items: center;
  width: 120px;
  height: 40px;
  font-size: 16px;
  box-sizing: border-box;
  border: 2px solid var(--black-10-10);
  box-shadow: 0px 50px 74.5px -16px var(--black-11-05);
  &:focus {
    width: 361px;
    outline: none;
    border: 2px solid var(--black-10-10);
    box-shadow: 0px 50px 74.5px -16px var(--black-11-05);
  }
  &:focus-visible {
    width: 361px;
    outline: none;
    border: 2px solid var(--black-10-10);
    box-shadow: 0px 50px 74.5px -16px var(--black-11-05);
  }
  &:focus-within {
    width: 361px;
    outline: none;
    border: 2px solid var(--black-10-10);
    box-shadow: 0px 50px 74.5px -16px var(--black-11-05);
  }
  &:hover {
    outline: none;
    border: 2px solid var(--black-10-10);
    box-shadow: 0px 50px 74.5px -16px var(--black-11-05);
  }
  @media (max-width: 800px) {
    height: 45px;
    font-size: 14px;
  }
  @media (max-width: 480px) {
    font-size: 13px;
  }
`;

export const HeaderSearchInput = forwardRef<InputRef, IHeaderSearchInputProps>(
  ({ placeholder, value, onChange, isLoading, style, onClearClick }, ref) => {
    const [inputFocus, setInputFocus] = useState<boolean>(false);
    return (
      <div className={styles['search-input']}>
        <HeaderSearchInputProvider>
          <StyledInput
            ref={ref}
            placeholder={placeholder}
            value={value}
            onChange={onChange}
            onFocus={() => setInputFocus(true)}
            onBlur={() => setInputFocus(false)}
            style={{
              ...style,
              zIndex: 0,
            }}
            prefix={
              <div className={styles['search-icon']}>
                <SearchIcon />
              </div>
            }
            suffix={
              value && inputFocus ? (
                <div className={styles['cancel-icon']} onClick={onClearClick}>
                  <CancelIcon />
                </div>
              ) : (
                <div></div>
              )
            }
          />
        </HeaderSearchInputProvider>
        {isLoading && (
          <div className={styles['search-input__loading-bar']}>
            <div className={styles['search-input__loading-content']}></div>
          </div>
        )}
      </div>
    );
  },
);
